const buildNum = '2.8.6.250410398';

export { buildNum };
